<template>
	<tr v-if="isChart && isRender" class="ms-tr shimmer">
		<td v-if="multiple" class="ms-td multiple-cell">
			<div class="shimmer"></div>
		</td>
		<td v-if="serial" class="ms-td serial text-center">
			<div class="shimmer"></div>
		</td>
		<td
			v-for="(col, colIndex) in columns"
			:key="col.dataField"
			class="ms-td ms-col-td"
			:class="col.cssCellClass"
			:style="styleWidth(col, false)"
			@click="row_click"
			@dblclick="row_dblclick"
		>
			<div class="shimmer"></div>
		</td>
		<td
			v-if="widgetOptions"
			class="ms-td widget-item"
			:style="styleWidth(widgetOptions, true)"
		>
			<div class="shimmer"></div>
		</td>
	</tr>
	<tr
		class="ms-tr"
		tabindex="0"
		@keydown="row_keydown"
		@focus="row_focus"
		v-else-if="isRender"
	>
		<td v-if="multiple" class="ms-td multiple-cell">
			<ms-checkbox
				:value="isSelected"
				@click="checkMultiple"
				class="center"
				ref="multiple"
				checkOnly
			/>
		</td>
		<td v-if="serial" class="ms-td serial text-center">
			{{ pageSize * (currentPage - 1) + index + 1 }}
		</td>
		<td
			v-for="(col, colIndex) in columns"
			:key="col.dataField"
			class="ms-td ms-col-td"
			:class="col.cssCellClass"
			:style="styleWidth(col, false)"
			@click="row_click"
			@dblclick="row_dblclick"
			:ref="`td-${col.dataField}`"
		>
			<component
				:is="col.template"
				:data="dataRow"
				:column="col"
				:dataRow="dataRow"
				:col="col"
				v-if="col.template"
				:rowSelected="rowSelected"
				:isSelected="isSelected"
			></component>
			<div
				class="flex"
				:class="[`justify-center`, col.cssClass]"
				v-else-if="col.isSerial"
			>
				<span>{{ index + 1 }}</span>
			</div>
			<div
				class="flex items-center"
				:class="[
					`justify-${col.align == 'right' ? 'end' : col.align}`,
					col.cssClass,
				]"
				v-else
			>
				<span :class="[`text-${col.align}`]" :ref="`text-${col.dataField}`">{{
					dataRow[col.dataField]
						| formatData({
							formatType: col.formatType,
							enumName: col.enumName,
							dataRow: dataRow,
						})
				}}</span>
				<div
					:class="['mi', 'mi-24', col.icon.type]"
					v-if="col.icon && col.icon.show(dataRow, col)"
					v-tooltip="{ ...col.icon.tooltip }"
				></div>
			</div>
		</td>
		<td
			v-if="widgetOptions"
			class="ms-td widget-item"
			:style="styleWidth(widgetOptions, true)"
		>
			<component
				:is="widgetOptions.components"
				:dataRow="dataRow"
				@widgetEvent="widgetEvent"
			></component>
		</td>
	</tr>
</template>
<script>
export default {
	name: 'msTr',
	props: {
		//Lưu thông tin của các cột
		columns: {},
		//Lưu dữ liệu của dòng
		dataRow: {},
		//Lưu cấu hình của cột chức năng
		widgetOptions: {},
		//Ẩn/hiện cột checkbox tích chọn nhiều cột
		multiple: {
			default: false,
			type: Boolean,
		},
		//Trạng thái tích chọn ở cột multiple
		isSelected: {
			default: false,
			type: Boolean,
		},
		index: {
			default: null,
			type: Number,
		},
		serial: {
			default: false,
			type: Boolean,
		},
		isChart: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			default: 1,
			type: Number,
		},
		pageSize: {
			default: 20,
			type: Number,
		},
		rowSelected: {
			default: null,
		},
	},
	updated() {
		const me = this;
	},
	computed: {},
	data() {
		return {
			isRender: true,
		};
	},
	methods: {
		//Cập nhật lại độ rộng của cột theo độ rộng cấu hình
		//Created by LTDAT
		styleWidth(col, widget) {
			const me = this;
			let width = col._width;
			if (widget) {
				width = col.width;
				if (me.columns && me.columns.length == 0) {
					return { 'min-width': `${width}px` };
				}
				return { width: `${width}px`, 'min-width': `${width}px` };
			} else {
				if (col.autoResize || (me.columns && me.columns.length <= 1)) {
					return { 'min-width': `${width}px` };
				} else {
					return { width: `${width}px`, 'min-width': `${width}px` };
				}
			}
		},
		//Emit sự kiện từ widget ra ngoài
		// Created by LTDAT (16.06.2020)
		widgetEvent(data, event) {
			const me = this;
			me.$emit('widgetEvent', data, event);
		},
		//Emit sự kiện click row ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_click(e) {
			const me = this;
			me.$emit('click', me.dataRow, e);
		},
		row_focus(e) {
			const me = this;
			me.$emit('focus', me.dataRow, e);
		},
		//Emit sự kiện dblclickRow ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_dblclick(e) {
			const me = this;
			me.$emit('dblclick', me.dataRow, e);
		},
		//Emit sự kiện ấn phím ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_keydown(e) {
			const me = this;
			me.$emit('keydown', me.dataRow, e);
		},
		//Sự kiện click vào nút chọn ở cột multiple
		//Created by LTDAT (28.05.2020)
		checkMultiple(event) {
			const me = this;
			me.$emit('clickMultiple', me.dataRow);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
</style>